import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Grid, Paper } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const PREFIX = 'ToursGallery';

const classes = {
  mainContainer: `${PREFIX}-mainContainer`,
  subContainer: `${PREFIX}-subContainer`,
  subContainerItem50: `${PREFIX}-subContainerItem50`,
  subContainerItem33: `${PREFIX}-subContainerItem33`,
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled(Box)(() => ({
  [`& .${classes.subContainer}`]: {
    height: '100%',
    flexDirection: 'column',
    display: 'flex',
    alignContent: 'flex-start',
    listStyle: 'none',
    margin: 0,
    padding: 0,
  },

  [`& .${classes.subContainerItem50}`]: {
    width: '100%',
    height: 'calc(50% - 4px)',
    marginBottom: '8px',
    position: 'relative',
    '&:last-child': {
      marginBottom: 0,
    },
  },

  [`& .${classes.subContainerItem33}`]: {
    width: '100%',
    height: 'calc(33.3333% - 4px)',
    marginBottom: '8px',
    position: 'relative',
    '&:last-child': {
      marginBottom: 0,
    },
  },
}));

const ToursGallerySkeleton = () => (
  <>
    <Root className={classes.mainContainer}>
      <Paper elevation={0} sx={{ display: { lg: 'none', md: 'block' } }}>
        <Skeleton variant="rectangular" width="100%" height="220px" />
      </Paper>
      <Paper elevation={0} sx={{ display: { lg: 'block', md: 'none' } }}>
        <Grid container spacing={1} className={classes.mainContainer}>
          <Grid item xs={12} md={7}>
            <Skeleton variant="rectangular" width="100%" height="300px" />
          </Grid>
          <Grid item xs={12} md={3}>
            <ul className={classes.subContainer}>
              <li className={classes.subContainerItem50}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
              </li>
              <li className={classes.subContainerItem50}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
              </li>
            </ul>
          </Grid>
          <Grid item xs={12} md={2}>
            <ul className={classes.subContainer}>
              <li className={classes.subContainerItem33}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
              </li>
              <li className={classes.subContainerItem33}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
              </li>
              <li className={classes.subContainerItem33}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
              </li>
            </ul>
          </Grid>
        </Grid>
      </Paper>
    </Root>
  </>
);

export default ToursGallerySkeleton;
